/* =============================================================
   VFW Product Page — Vanilla JS
   Handles: gallery, variant selection, AJAX cart, tabs, FAQ
   ============================================================= */
(function () {
  'use strict';

  /* ── Gallery ──────────────────────────────────────────────── */
  function initGallery() {
    var thumbs = document.querySelectorAll('.vfw-gallery_thumb');
    var mainImg = document.getElementById('vfw-main-img');
    var mainStage = document.querySelector('.vfw-gallery_main');

    function clearVideoPlayers() {
      if (!mainStage) return;
      var v = document.getElementById('vfw-stage-video');
      var e = document.getElementById('vfw-stage-embed');
      if (v) { v.pause(); v.remove(); }
      if (e) e.remove();
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var mediaType = thumb.dataset.mediaType || 'image';
        var alt = thumb.dataset.alt || '';

        clearVideoPlayers();

        if (mediaType === 'video') {
          var videoSrc = thumb.dataset.videoSrc;
          if (mainImg) mainImg.style.display = 'none';
          if (videoSrc && mainStage) {
            var video = document.createElement('video');
            video.id = 'vfw-stage-video';
            video.className = 'vfw-gallery_main-img';
            video.controls = true;
            video.playsInline = true;
            video.setAttribute('playsinline', '');
            var source = document.createElement('source');
            source.src = videoSrc;
            source.type = 'video/mp4';
            video.appendChild(source);
            mainStage.appendChild(video);
            video.play().catch(function () {});
          }
        } else if (mediaType === 'external_video') {
          var embedSrc = thumb.dataset.embedSrc;
          if (mainImg) mainImg.style.display = 'none';
          if (embedSrc && mainStage) {
            var iframe = document.createElement('iframe');
            iframe.id = 'vfw-stage-embed';
            iframe.className = 'vfw-gallery_main-img';
            iframe.src = embedSrc;
            iframe.setAttribute('frameborder', '0');
            iframe.setAttribute('allow', 'autoplay; encrypted-media; fullscreen');
            iframe.setAttribute('allowfullscreen', '');
            mainStage.appendChild(iframe);
          }
        } else {
          if (mainImg) {
            mainImg.style.display = '';
            var src = thumb.dataset.src;
            if (src) {
              mainImg.src = src;
              mainImg.srcset = '';
              mainImg.alt = alt;
            }
          }
        }

        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  /* ── Gallery Scroll Arrows ────────────────────────────────── */
  function initGalleryScroll() {
    var thumbsEl = document.getElementById('vfw-gallery-thumbs');
    if (!thumbsEl) return;

    /* Only add arrows when content actually overflows */
    if (thumbsEl.scrollHeight <= thumbsEl.clientHeight + 2) return;

    var col = thumbsEl.closest('.vfw-gallery_thumbs-col');
    if (!col) return;

    var STEP = 88 * 2; /* scroll two thumbs at a time */

    var btnUp = document.createElement('button');
    btnUp.type = 'button';
    btnUp.className = 'vfw-gallery_scroll-btn';
    btnUp.setAttribute('aria-label', 'Scroll thumbnails up');
    btnUp.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="18 15 12 9 6 15"/></svg>';

    var btnDown = document.createElement('button');
    btnDown.type = 'button';
    btnDown.className = 'vfw-gallery_scroll-btn';
    btnDown.setAttribute('aria-label', 'Scroll thumbnails down');
    btnDown.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>';

    col.insertBefore(btnUp, thumbsEl);
    col.appendChild(btnDown);

    btnUp.addEventListener('click', function () { thumbsEl.scrollBy({ top: -STEP, behavior: 'smooth' }); });
    btnDown.addEventListener('click', function () { thumbsEl.scrollBy({ top: STEP, behavior: 'smooth' }); });

    function syncArrows() {
      btnUp.classList.toggle('is-disabled', thumbsEl.scrollTop <= 0);
      btnDown.classList.toggle('is-disabled', thumbsEl.scrollTop + thumbsEl.clientHeight >= thumbsEl.scrollHeight - 2);
    }
    thumbsEl.addEventListener('scroll', syncArrows, { passive: true });
    syncArrows();
  }

  /* ── Finish / Color Swatches ──────────────────────────────── */
  function initSwatches() {
    document.querySelectorAll('.vfw-swatch').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var oi = swatch.dataset.optionIndex;
        var val = swatch.dataset.swatchValue;

        /* Activate clicked swatch */
        document.querySelectorAll('.vfw-swatch[data-option-index="' + oi + '"]').forEach(function (s) {
          s.classList.remove('is-active');
        });
        swatch.classList.add('is-active');

        /* Sync hidden select and fire change so variant JS picks it up */
        var sel = document.querySelector('.vfw-panel_select--hidden[data-option-index="' + oi + '"]');
        if (sel) {
          sel.value = val;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }

        /* Update "FINISH: [name]" label */
        var label = document.querySelector('[data-swatch-label="' + oi + '"]');
        if (label) label.textContent = val;
      });
    });
  }

  /* ── Quantity Stepper ─────────────────────────────────────── */
  function initStepper() {
    document.querySelectorAll('.vfw-panel_stepper-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.closest('.vfw-panel_stepper').querySelector('.vfw-panel_qty');
        if (!input) return;
        var val = parseInt(input.value, 10) || 1;
        if (btn.dataset.stepper === 'increment') {
          input.value = val + 1;
        } else if (btn.dataset.stepper === 'decrement' && val > 1) {
          input.value = val - 1;
        }
        updateTotalPrice();
      });
    });
  }

  /* ── Shared Utilities ────────────────────────────────────── */
  function formatMoney(cents) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
  }

  function updateTotalPrice() {
    var priceEl = document.getElementById('vfw-price');
    var qtyEl = document.getElementById('vfw-qty');
    if (!priceEl || !priceEl.dataset.unitPrice) return;
    var unitPrice = parseInt(priceEl.dataset.unitPrice, 10);
    var qty = parseInt(qtyEl ? qtyEl.value : 1, 10) || 1;
    priceEl.textContent = formatMoney(unitPrice * qty);
  }

  /* ── Variant Selection ────────────────────────────────────── */
  function initVariants() {
    const form = document.querySelector('.vfw-product-form');
    if (!form) return;

    const jsonEl = form.querySelector('[data-product-variants]');
    if (!jsonEl) return;

    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    var selects = Array.from(form.querySelectorAll('.vfw-panel_select[data-option-index]'));
    var priceEl = document.querySelector('.vfw-panel_price');
    var atcBtn = form.querySelector('.vfw-panel_atc');
    var statusEl = document.querySelector('.vfw-panel_status');
    var variantIdInput = form.querySelector('[name="id"]');

    function getSelected() {
      return selects.map(function (s) { return s.value; });
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      }) || null;
    }

    function updateUI(variant) {
      if (!variant) {
        if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = 'Unavailable'; }
        return;
      }

      if (variantIdInput) variantIdInput.value = variant.id;

      if (priceEl) {
        priceEl.dataset.unitPrice = variant.price;
        updateTotalPrice();
      }

      if (atcBtn) {
        if (variant.available) {
          atcBtn.disabled = false;
          atcBtn.innerHTML = 'Add to Cart <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>';
        } else {
          atcBtn.disabled = true;
          atcBtn.textContent = 'Sold Out';
        }
      }

      if (statusEl) {
        var dot = statusEl.querySelector('.vfw-panel_status-dot');
        var text = statusEl.querySelector('.vfw-panel_status-text');
        statusEl.className = 'vfw-panel_status ' + (variant.available ? 'vfw-panel_status--in-stock' : 'vfw-panel_status--mto');
        if (text) text.textContent = variant.available ? 'In Stock' : 'Made to Order — Manufacturing begins after purchase';
      }

      /* Switch gallery to variant image */
      if (variant.featured_image) {
        var mainImg = document.getElementById('vfw-main-img');
        if (mainImg) {
          mainImg.src = variant.featured_image.src;
          mainImg.alt = variant.featured_image.alt || '';
        }
        /* Activate matching thumb */
        var thumbs = document.querySelectorAll('.vfw-gallery_thumb');
        thumbs.forEach(function (t) {
          if (t.dataset.src === variant.featured_image.src) {
            thumbs.forEach(function (x) { x.classList.remove('is-active'); });
            t.classList.add('is-active');
          }
        });
      }

      /* Update URL without reload */
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    selects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        updateUI(findVariant(getSelected()));
      });
    });

    /* Init on page load */
    var params = new URLSearchParams(window.location.search);
    var urlVariantId = params.get('variant');
    if (urlVariantId) {
      var v = variants.find(function (x) { return String(x.id) === urlVariantId; });
      if (v) {
        /* Pre-select option dropdowns */
        selects.forEach(function (sel, i) {
          var opt = Array.from(sel.options).find(function (o) { return o.value === v.options[i]; });
          if (opt) sel.value = opt.value;
        });
        updateUI(v);
        return;
      }
    }
    updateUI(findVariant(getSelected()));
  }

  /* ── AJAX Add-to-Cart ─────────────────────────────────────── */
  function initCart() {
    var form = document.querySelector('.vfw-product-form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('.vfw-panel_atc');
      var data = new FormData(form);

      btn.textContent = 'Adding…';
      btn.disabled = true;
      btn.classList.add('vfw-panel_atc--loading');

      fetch('/cart/add.js', { method: 'POST', body: data })
        .then(function (r) { return r.json(); })
        .then(function (item) {
          if (item.status) throw new Error(item.description || 'Error');

          btn.innerHTML = 'Added ✓';
          btn.style.background = '#2E7D32';

          /* Refresh cart count in Horizon header */
          return fetch('/cart.js');
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          /* Dispatch event — Horizon listens for cart updates */
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));

          /* Try to update Horizon cart bubble directly */
          var bubbles = document.querySelectorAll('[data-cart-count], .cart-count-bubble, .header-actions__cart-count');
          bubbles.forEach(function (el) {
            el.textContent = cart.item_count;
          });

          setTimeout(function () {
            btn.innerHTML = 'Add to Cart <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>';
            btn.style.background = '';
            btn.disabled = false;
            btn.classList.remove('vfw-panel_atc--loading');
          }, 2000);
        })
        .catch(function (err) {
          btn.textContent = err.message || 'Error — Try Again';
          btn.style.background = '#c0392b';
          setTimeout(function () {
            btn.innerHTML = 'Add to Cart <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>';
            btn.style.background = '';
            btn.disabled = false;
            btn.classList.remove('vfw-panel_atc--loading');
          }, 2500);
        });
    });
  }

  /* ── Tabs ─────────────────────────────────────────────────── */
  function initTabs() {
    var section = document.querySelector('.vfw-tabs');
    if (!section) return;

    var btns = Array.from(section.querySelectorAll('.vfw-tabs_nav-btn'));
    var panels = Array.from(section.querySelectorAll('.vfw-tabs_panel'));

    btns.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        btns.forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-selected', 'false'); });
        panels.forEach(function (p) { p.classList.remove('is-active'); });
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');
        if (panels[i]) panels[i].classList.add('is-active');
      });
    });
  }

  /* ── FAQ Accordion ────────────────────────────────────────── */
  function initFaq() {
    document.querySelectorAll('.vfw-faq-item_q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.vfw-faq-item');
        var wasOpen = item.classList.contains('is-open');
        document.querySelectorAll('.vfw-faq-item').forEach(function (i) { i.classList.remove('is-open'); });
        if (!wasOpen) item.classList.add('is-open');
      });
    });
  }

  /* ── Related Products (AJAX Recommendations) ─────────────── */
  function initRelated() {
    var grid = document.getElementById('vfw-related-grid');
    if (!grid) return;
    var productId = grid.dataset.productId;
    var limit = grid.dataset.limit || 4;
    if (!productId) return;

    /* In dev-theme preview, carry the preview ID so clicks stay in the preview */
    var previewId = new URLSearchParams(window.location.search).get('preview_theme_id');
    var previewParam = previewId ? '?preview_theme_id=' + previewId : '';

    fetch('/recommendations/products.json?product_id=' + productId + '&limit=' + limit + '&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = data.products;
        if (!products || !products.length) {
          grid.closest('.vfw-related').style.display = 'none';
          return;
        }
        grid.innerHTML = products.map(function (p) {
          var productUrl = (p.url || '/products/' + p.handle) + previewParam;
          var img = p.featured_image;
          var imgHtml = img
            ? '<img src="' + img.src + '" alt="' + (img.alt || p.title).replace(/"/g, '&quot;') + '" loading="lazy">'
            : '';
          var metaHtml = p.product_type
            ? '<p class="vfw-related_card-meta">' + p.product_type + '</p>'
            : '';
          return '<a href="' + productUrl + '" class="vfw-related_card">' +
            '<div class="vfw-related_card-media">' + imgHtml + '</div>' +
            '<div class="vfw-related_card-info">' +
              '<p class="vfw-related_card-title">' + p.title + '</p>' +
              metaHtml +
              '<p class="vfw-related_card-price">' + formatMoney(p.price_min) + '</p>' +
            '</div>' +
          '</a>';
        }).join('');
      })
      .catch(function () {
        var section = grid.closest('.vfw-related');
        if (section) section.style.display = 'none';
      });
  }

  /* ── Tab Content Accordion ──────────────────────────────────*/
  function initTabReadMore() {
    var chevron = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>';

    document.querySelectorAll('[data-expandable]').forEach(function (content) {
      if ((content.textContent || '').trim().length < 500) return;

      /* Wrap content in accordion container */
      var accordion = document.createElement('div');
      accordion.className = 'vfw-tabs_accordion is-clamped';
      content.parentNode.insertBefore(accordion, content);
      accordion.appendChild(content);

      /* Toggle button lives inside the accordion, below content */
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'vfw-tabs_accordion-btn';
      btn.innerHTML = '<span class="vfw-tabs_accordion-label">Read More</span>' + chevron;
      accordion.appendChild(btn);

      var label = btn.querySelector('.vfw-tabs_accordion-label');

      function expand() {
        accordion.classList.remove('is-clamped');
        label.textContent = 'Show Less';
      }

      function collapse() {
        accordion.classList.add('is-clamped');
        label.textContent = 'Read More';
        var panel = accordion.closest('.vfw-tabs_panel');
        if (panel) panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      /* Click anywhere in the container to toggle */
      accordion.addEventListener('click', function () {
        if (accordion.classList.contains('is-clamped')) {
          expand();
        } else {
          collapse();
        }
      });
    });
  }

  /* ── Specs / Fitment Dynamic Sync ───────────────────────── */
  function initSpecsSync() {
    document.querySelectorAll('.vfw-panel_select[data-option-name]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var oname = (sel.dataset.optionName || '').toLowerCase();
        var val = sel.value;
        if (oname === 'size' || oname === 'wheel size') {
          var el = document.getElementById('vfw-spec-size');
          if (el) el.textContent = val;
        } else if (oname === 'finish' || oname === 'color' || oname === 'colour') {
          var el = document.getElementById('vfw-spec-finish');
          if (el) el.textContent = val;
        }
      });
    });
  }

  /* ── Boot ─────────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    initGallery();
    initGalleryScroll();
    initSwatches();
    initStepper();
    initVariants();
    initSpecsSync();
    initCart();
    initTabs();
    initFaq();
    initRelated();
    initTabReadMore();

    /* Zero outer .vfw-section wrapper padding on FAQ section — runs only on product pages since vfw-product.js is product-only */
    var faqInner = document.querySelector('.vfw-faq');
    if (faqInner && faqInner.parentElement && faqInner.parentElement.classList.contains('vfw-section')) {
      faqInner.parentElement.style.setProperty('padding-top', '0', 'important');
      faqInner.parentElement.style.setProperty('padding-bottom', '0', 'important');
    }
  });

}());
